import config from "../../../config/common";

const getFaceAndBodyCarouselAdjustedPosition = advertPosition => {
  const {
    faceAndBody: { carouselPosition }
  } = config;

  return advertPosition !== null && advertPosition <= carouselPosition
    ? carouselPosition + 1
    : carouselPosition;
};

export default getFaceAndBodyCarouselAdjustedPosition;
